import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {StyledSelectRequired} from './styled';
import {Layout, ListItem, SelectValue} from '@phonectas/unifon-ui-kit';

interface BillingGroupSelectorProps {
    billingGroups?: string[];
    onChange: (value: string) => void;
	required?: boolean;
}

const BillingGroupSelector: React.FC<BillingGroupSelectorProps> = ({billingGroups, onChange, required}) => {
	const [t] = useTranslation();
	const [selectedGroup, setSelectedGroup] = useState<string | null>(null);

	const handleGroupChange = useCallback((val: SelectValue, _e: React.SyntheticEvent, _name: string) => {
		let value = '';
		if (typeof val === 'string') {
			value = val ?? '';
		} else if (Array.isArray(val)) {
			value = val[0] !== undefined ? String(val[0]) : '';
		}
		setSelectedGroup(value || null);
		onChange(value || '');
	}, [onChange]);

	return (
		<Layout>
			<StyledSelectRequired
				label={t('Billing Group')}
				name='item_id'
				onChange={handleGroupChange}
				value={selectedGroup}
				compact
				required={required || false}
			>
				{(billingGroups ?? []).map((group) => (
					<ListItem
						key={group}
						value={group}
						selected={selectedGroup === group}
						primaryText={group}    
					/>
				))}
			</StyledSelectRequired>
		</Layout>
	);
};

export default BillingGroupSelector;


